module.exports = __webpack_public_path__ + "img/logo-ika.e5fb6909.png";